module.exports = __webpack_public_path__ + "static/media/Simran_Arora_CV.86a06b1c.pdf";